export const ROLES = {
  // PharmUPP
  ADMIN: "administrator",
  // CDO
  ADHERENT_ADVISOR: "adherent-advisor",
  // UPP
  UPP_PRESIDENT: "upp-president",
  UPP_REPRESENTATIVE: "upp-representative",
  UPP_TREASURER: "upp-treasurer",
  // Adherent
  ADHERENT_HOLDER: "adherent-holder",
  ADHERENT_TEAM: "adherent-team",
  ADHERENT_EMPLOYEE: "adherent-employee",
  // Contact Laboratoire
  EXTERN_CONTACT_LABORATORY: "extern-contact-laboratory",
} as const

type ValueOf<T> = T[keyof T]
export type Role = ValueOf<typeof ROLES>
